import { privateInstance } from "../configs";

export const wasteCauseApi = {
  async getInventoryWasteCauses(params) {
    let url = "/inventory/api/wastecause/";

    if (params) {
      if (params.store) url += `?store=${params.store}/`;
    }

    const res = await privateInstance.get(url);
    return res.data;
  },
  async postInventoryWasteCause(wastecause) {
    let url = "/inventory/api/wastecause/";
    const res = await privateInstance.post(url, wastecause);
    return res.data;
  },
  async patchInventoryWasteCause(wastecause) {
    let url = `/inventory/api/wastecause/${wastecause.id}/`;
    const res = await privateInstance.patch(url, wastecause);
    return res.data;
  }
};
